<template>
  <section
    class="-m-1 w-[280px] overflow-hidden"
    data-test="message-views-flyout"
  >
    <ul class="flex max-h-[320px] flex-col gap-[14px] overflow-y-auto px-4 py-[11px]">
      <li
        v-for="viewer in viewers"
        :key="viewer.contactId"
      >
        <message-view-list-item
          :author="viewer.contactId"
          :timestamp="viewer.timestamp"
        />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useStoreLastReadEventIds } from '@/entities/room'

import MessageViewListItem from './message-view-list-item.vue'

const props = defineProps<{
  eventId: number
  pServed: string
}>()

const lastReadStore = useStoreLastReadEventIds()
const {
  lastMessageEventIdByRoomAndContactId,
  readTimestampsByMessageEventId,
} = storeToRefs(lastReadStore)
const { getViewersByMessageEventId } = lastReadStore

const viewers = computed(() => {
  void lastMessageEventIdByRoomAndContactId.value[props.pServed]
  void readTimestampsByMessageEventId.value
  return getViewersByMessageEventId(props.pServed, props.eventId)
})
</script>
